import { Component } from '@angular/core';

@Component({
  selector: 'thehubz-user-professional-information',
  templateUrl: './user-professional-information.component.html',
  styleUrls: ['./user-professional-information.component.scss']
})
export class UserProfessionalInformationComponent {}
